import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseServiceFacade, GenericApiCall } from '../../../common/store/types';
import { AppState } from '../types';
import {
  InsuranceClaimFormModel,
  InsuranceClaimModel,
  InsuranceClaimRejectReasonModel,
  InsuranceClaimStatus,
  InsuranceClaimStatusFlow,
  InsuranceClaimStatusHistoryModel,
} from './types';
import { Action } from '../view/types';
import { insuranceClaimActions } from './insurance-claim.actions';
import { insuranceClaimSelectors } from './insurance-claim.selector';

@Injectable()
export class InsuranceClaimService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }

  getById: GenericApiCall<InsuranceClaimModel, string> = this.genericApiCall(
    insuranceClaimActions.getById,
    insuranceClaimSelectors.getById,
    true,
  );
  getByUniqueId: GenericApiCall<InsuranceClaimModel, string> =
    this.genericApiCall(
      insuranceClaimActions.getByUniqueId,
      insuranceClaimSelectors.getByUniqueId,
      true,
    );
  createInstance: GenericApiCall<InsuranceClaimFormModel, number> =
    this.genericApiCall(
      insuranceClaimActions.createInstance,
      insuranceClaimSelectors.createInstance,
      true,
    );
  add: GenericApiCall<InsuranceClaimModel, InsuranceClaimFormModel> =
    this.genericApiCall(
      insuranceClaimActions.add,
      insuranceClaimSelectors.add,
      true,
    );
  update: GenericApiCall<InsuranceClaimModel, InsuranceClaimFormModel> =
    this.genericApiCall(
      insuranceClaimActions.update,
      insuranceClaimSelectors.update,
      true,
    );
  generateDocuments: GenericApiCall<boolean, number> = this.genericApiCall(
    insuranceClaimActions.generateDocuments,
    insuranceClaimSelectors.generateDocuments,
    true,
  );
  requestValidation: GenericApiCall<boolean, number> = this.genericApiCall(
    insuranceClaimActions.requestValidation,
    insuranceClaimSelectors.requestValidation,
    true,
  );
  validate: GenericApiCall<boolean, number> = this.genericApiCall(
    insuranceClaimActions.validate,
    insuranceClaimSelectors.validate,
    true,
  );
  openDossierToTransmitter: GenericApiCall<boolean, number> =
    this.genericApiCall(
      insuranceClaimActions.openDossierToTransmitter,
      insuranceClaimSelectors.openDossierToTransmitter,
      true,
    );
  openClaim: GenericApiCall<boolean, number> = this.genericApiCall(
    insuranceClaimActions.openClaim,
    insuranceClaimSelectors.openClaim,
    true,
  );
  close: GenericApiCall<boolean, number> = this.genericApiCall(
    insuranceClaimActions.close,
    insuranceClaimSelectors.close,
    true,
  );
  reopen: GenericApiCall<boolean, number> = this.genericApiCall(
    insuranceClaimActions.reopen,
    insuranceClaimSelectors.reopen,
    true,
  );
  reject: GenericApiCall<boolean, InsuranceClaimRejectReasonModel> =
    this.genericApiCall(
      insuranceClaimActions.reject,
      insuranceClaimSelectors.reject,
      true,
    );
  getStatusHistory: GenericApiCall<
    InsuranceClaimStatusHistoryModel,
    { insuranceClaimId: number; insuranceClaimStatusHistoryId: number }
  > = this.genericApiCall(
    insuranceClaimActions.getStatusHistory,
    insuranceClaimSelectors.getStatusHistory,
    true,
  );
  updateStatusHistory: GenericApiCall<
    InsuranceClaimStatusHistoryModel,
    InsuranceClaimStatusHistoryModel
  > = this.genericApiCall(
    insuranceClaimActions.updateStatusHistory,
    insuranceClaimSelectors.updateStatusHistory,
    true,
  );
  deleteStatusHistory: GenericApiCall<
    boolean,
    { insuranceClaimId: number; insuranceClaimStatusHistoryId: number }
  > = this.genericApiCall(
    insuranceClaimActions.deleteStatusHistory,
    insuranceClaimSelectors.deleteStatusHistory,
    true,
  );
  getStatusFlow: GenericApiCall<
    InsuranceClaimStatusFlow[],
    InsuranceClaimStatus
  > = this.genericApiCall(
    insuranceClaimActions.getStatusFlow,
    insuranceClaimSelectors.getStatusFlow,
    true,
  );
  getStatusActions: GenericApiCall<Action[], string> = this.genericApiCall(
    insuranceClaimActions.getStatusActions,
    insuranceClaimSelectors.getStatusActions,
    true,
  );
}
